import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import DataTable from "react-data-table-component";
import Hdashboard from "../../../components/Hdashboard";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import { CountryUsersListApi, CountryStudentListDetailsApi } from "../../../api/apiHandler";
import customStyles from "../../../utils/dataTableStyles";
import Logo from "../../../components/Logo";
import moment from "moment";

export default function CountryUsersList({ isLoader }) {
    const location = useLocation();
    const navigate = useNavigate();
    const stateParams = location.state || {};
    const [data, setData] = useState([]);
    const [paginationOption, setPaginationOption] = useState(10);
    const [paginationOptions, setPaginationOptions] = useState([]);

    useEffect(() => {
        if (!stateParams.category) {
            navigate(-1);
            return;
        }
        fetchUsers();
    }, []);

    const fetchUsers = () => {
        let requestData = {};

        if (stateParams.selectedPeriod === 'daily' || stateParams.selectedPeriod === 'weekly') {
            requestData = {
                type: stateParams.selectedPeriod,
                startDate: stateParams.startDate,
                endDate: stateParams.endDate
            };
        } else if (stateParams.selectedPeriod === 'monthly') {
            requestData = {
                type: 'monthly',
                startDate: stateParams.startMonth,
                endDate: stateParams.endMonth
            };
        } else if (stateParams.selectedPeriod === 'yearly') {
            requestData = {
                type: 'yearly',
                startYear: stateParams.startYear,
                endYear: stateParams.endYear
            };
        }

        requestData.category = stateParams.category;
        requestData.country_name = stateParams.country_name;

        isLoader(true);
        const fetchApi = stateParams.reportType === 'student' ? CountryStudentListDetailsApi : CountryUsersListApi;

        fetchApi(requestData)
            .then((response) => {
                if (response.code === "1") {
                    const dataWithRowCount = response.data.map((row, index) => ({ ...row, count: index + 1 }));
                    setData(dataWithRowCount);
                    const newPaginationOptions = [];
                    for (let i = 10; i <= dataWithRowCount.length; i += 10) {
                        newPaginationOptions.push(i);
                    }
                    if (dataWithRowCount.length <= 100) {
                        newPaginationOptions.push(dataWithRowCount.length);
                    }
                    setPaginationOptions(newPaginationOptions);
                } else {
                    setData([]);
                }
            })
            .catch((error) => {
                setData([]);
            })
            .finally(() => {
                isLoader(false);
            });
    };

    const handleBack = () => {
        navigate(-1);
    };

    const handlePaginationChange = (rowsPerPage, currentPage) => {
        setPaginationOption(rowsPerPage);
    };

    // Navigate to learner list when clicking on learner count
    const handleLearnerClick = (row) => {
        if (stateParams.category === 'after_school') {
            // After School: show class list for this user
            navigate('/after_school_class_list', {
                state: {
                    user_id: row.id,
                    user_name: row.full_name,
                }
            });
        } else {
            // Parent (below_18): show learner list for this parent
            navigate('/parent_learner_details', {
                state: {
                    user_id: row.id,
                    user_name: row.full_name,
                }
            });
        }
    };

    const learnerColumn = {
        name: stateParams.category === 'after_school' ? 'No. of Classes' : 'No. of Learners',
        selector: row => row.total_learners,
        sortable: true,
        width: "200px",
        cell: row => (
            <div
                className="text-primary"
                style={{ cursor: "pointer", textDecoration: "underline", fontWeight: "600" }}
                onClick={() => handleLearnerClick(row)}
            >
                {row.total_learners}
            </div>
        )
    };

    // Check if at least one row has total_learners
    const hasLearnerData = data?.some(
        row => row.total_learners !== null &&
            row.total_learners !== undefined &&
            row.total_learners !== ''
    );
    const columns = [
        {
            name: 'Sr. No',
            selector: row => row.count,
            sortable: false,
            width: "100px"
        },
        {
            name: 'Profile',
            selector: row => row.profile_image,
            sortable: false,
            width: "150px",
            cell: row => (
                <div className="d-flex my-2">
                    <img className="imageTable_rounded" src={row.profile_image} alt="profile" style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "50%" }} />
                </div>
            )
        },
        {
            name: 'Name',
            selector: row => row.full_name,
            sortable: true,
            width: "250px"
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
            width: "300px"
        },
        {
            name: 'Country',
            selector: row => row.country_name,
            sortable: true,
            width: "200px"
        },

        // Conditionally add column
        ...(hasLearnerData ? stateParams.category != 'above_18' ? [learnerColumn] : [] : []),
        {
            name: 'Registered On',
            selector: row => row.created_at,
            sortable: true,
            width: "200px",
            cell: row => moment(row.created_at).format('YYYY-MM-DD HH:mm:ss')
        }
    ];

    const getFilterLabel = () => {
        let label = `Users in ${stateParams.country_name || 'Selected Country'} `;
        if (stateParams.category === 'teacher') label = `Teachers in ${stateParams.country_name} `;
        if (stateParams.category === 'organization') label = `Organizations in ${stateParams.country_name} `;
        if (stateParams.category === 'org_teacher') label = `Organization Teachers in ${stateParams.country_name} `;
        if (stateParams.category === 'below_18') label = `Parents (Below 18) in ${stateParams.country_name} `;
        if (stateParams.category === 'above_18') label = `Students (Above 18) in ${stateParams.country_name} `;
        if (stateParams.category === 'after_school') label = `After School in ${stateParams.country_name} `;
        if (stateParams.category === 'learner') label = `Learners in ${stateParams.country_name} `;

        if (stateParams.selectedPeriod === "yearly") {
            return `${label} From ${stateParams.startYear} To ${stateParams.endYear}`;
        }
        if (stateParams.selectedPeriod === "monthly") {
            return `${label} From ${stateParams.startMonth} To ${stateParams.endMonth}`;
        }
        if (stateParams.selectedPeriod === "daily" || stateParams.selectedPeriod === "weekly") {
            return `${label} From ${stateParams.startDate} To ${stateParams.endDate}`;
        }
        return label;
    };

    return <>
        <JqueryLoad />
        <Hdashboard />
        <header className="dashboard-toolbar d-lg-flex justify-content-between">
            <div className="align-items-center justify-content-between d-flex">
                <div className="d-flex align-items-center">
                    <a className="menu-toggle align-items-center d-lg-none d-flex">
                        <i className="fa fa-bars" />
                    </a>
                    <a href="index.php" className="d-lg-none d-block brand-logo">
                        <img src="./assets/images/logo.png" alt="logo" />
                    </a>
                </div>
            </div>
        </header>

        <section className="main_sec">
            <div className="mt-4 mx-5">
                <div>
                    <span onClick={handleBack} style={{ cursor: "pointer" }}>
                        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313"></path>
                        </svg>
                        <span className="ms-2">Back</span>
                    </span>
                </div>
                <p className="fs-4 fw-500 text-center mb-5">{getFilterLabel()}</p>

                <div className="mt-4">
                    {data && data.length > 0 ? (
                        <DataTable
                            columns={columns}
                            data={data}
                            pagination
                            paginationPerPage={paginationOption}
                            onChangeRowsPerPage={handlePaginationChange}
                            paginationRowsPerPageOptions={paginationOptions}
                            customStyles={customStyles}
                        />
                    ) : (
                        <p className="mt-5 text-center text-purple fw-500 fs-3 mt-5">No data Found</p>
                    )}
                </div>
            </div>
        </section>
    </>;
}
